import { render, staticRenderFns } from "./eventEditPage.vue?vue&type=template&id=816aad56&"
import script from "./eventEditPage.vue?vue&type=script&lang=ts&"
export * from "./eventEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports